import { bp } from "theme";
import styled, { css } from "styled-components";
import { JobDescriptionType } from "../types";

export const Heading = styled.h2`
	margin: 0 0 8px;
	font-weight: ${(props) => props.theme.fontWeight.medium};
	font-size: 16px;
	line-height: 1.5;
	color: #31445a;

	${bp.md} {
		font-size: 20px;
		font-weight: 600;
		line-height: 1.4;
		letter-spacing: 0.3px;
	}
`;

export const Wrapper = styled.div``;

export const JobDetailBlockHeading = styled.div`
	font-weight: ${(props) => props.theme.fontWeight.normal};
	font-size: 12px;
	line-height: 1.33;
	color: #6b7c8f;

	${bp.md} {
		font-size: 14px;
		line-height: 1.43;
	}
`;

export const JobDetailBlockValue = styled.div`
	font-weight: ${(props) => props.theme.fontWeight.medium};
	font-size: 12px;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.33;
	letter-spacing: normal;
	text-align: left;
	color: #31445a;
	margin-bottom: 4px;
	word-wrap: break-word;
	word-break: break-word;

	${bp.md} {
		font-size: 16px;
		line-height: 1.5;
	}
`;

export const JobDetailBlockContainer = styled.div`
	display: flex;
	align-items: flex-start;
	margin-bottom: 8px;
`;

export const JobDescriptionSection = styled.div`
	margin-bottom: 24px;

	${bp.md} {
		margin-top: 22px;
	}
`;

export const Container = styled.div`
	padding: 0;
	border: 1px solid #123;
`;

export const DescriptionContent = styled.div`
	margin-left: 8px;
`;

export const DescriptionText = styled.div<DescriptionTextType>`
	position: relative;
	font-size: 12px;
	color: #31445a;
	height: ${({ showBlendElement }) => (showBlendElement ? "120px" : "auto")};

	overflow: hidden;
	table {
		font-size: 14px;
	}
	li {
		list-style: disc;
	}
	white-space: pre-line;

	p {
		// word-break: break-word;
		margin: 0;
	}
	ol,
	ul {
		margin: 8px 0 8px 16px;
	}
	h4 {
		font-size: 16px;
		font-weight: 600;
		margin: 16px 0 4px 0;
	}
	h2 {
		font-weight: 500;
		font-size: 14px;
	}
	&:after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: ${({ showBlendElement }) => (showBlendElement ? "50px" : "0")};
		background: linear-gradient(transparent, #fff);
	}

	${bp.md} {
		font-size: 14px;

		h2 {
			font-weight: ${(props) => props.theme.fontWeight.medium};
			font-size: 16px;
		}
	}
`;

export const DescriptionTextFull = styled.div<JobDescriptionType>`
	position: relative;
	font-size: 12px;
	color: #31445a;
	display: none;
	table {
		font-size: 14px;
	}
	li {
		list-style: disc;
	}
	white-space: pre-line;

	p {
		// word-break: break-word;
		margin: 0;
	}
	ol,
	ul {
		margin: 8px 0 8px 16px;
	}
	h4 {
		font-size: 16px;
		font-weight: 600;
		margin: 16px 0 4px 0;
	}
	h2 {
		font-weight: 500;
		font-size: 14px;
	}
	${bp.md} {
		font-size: 14px;

		h2 {
			font-weight: 500;
			font-size: 16px;
		}
	}

	${({ showJobDescription }) =>
		showJobDescription &&
		css`
			display: block;
		`}
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	${bp.md} {
		padding: 0;
		margin: 16px 0 0;
	}
`;

export const ReadDescriptionButton = styled.button`
	border: none;
	outline: none;
	font-size: 12px;
	line-height: 16px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #1f8268;
	height: 28px;
	cursor: pointer;
	font-weight: 600;
	margin-left: auto;

	${bp.md} {
		font-size: 14px;
		line-height: 20px;
		font-weight: 600;
	}

	span {
		margin-right: 8px;
	}
`;

export const JobDetailSection = styled.div`
	display: grid;
	grid-template-columns: 1fr;

	${bp.md} {
		grid-template-columns: 1fr 1fr;
	}
`;

export const IconContainer = styled.div`
	height: 24px;
	min-width: 24px;
`;

export const EducationDegreeText = styled.span`
	font-size: 12px;
`;

export const MobileContainer = styled.div`
	${bp.md} {
		display: none;
	}
`;

export const DesktopContainer = styled.div`
	display: none;
	${bp.md} {
		margin-top: 22px;
		display: block;
	}
`;

export const JobDescriptionContainer = styled.div`
	margin-top: 22px;
	position: relative;
	overflow: hidden;
`;

type DescriptionTextType = {
	showBlendElement: boolean;
};
